import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router";
import { useOnLogout } from "../modules/app-auth/hook/index";

// AUTH CLIENTE
import LoginCli from "../../app/modules/app-authcli/login1/index";
import ValidarCedula from "../../app/modules/app-authcli/validarcedula/index";
import OtpCli from "../../app/modules/app-authcli/otp/index";
import OtpRegistro from "../../app/modules/app-authcli/otpRegistro/index";
import Welcome from "../modules/app-authcli/welcome1/index";
import Datos from "../modules/app-authcli/datos/index";
import Terminos from "../modules/app-authcli/terminos/index";

import Login from "../../app/modules/app-auth/login/index";
import Otp from "../../app/modules/app-auth/otp/index";
import Signup from "../modules/app-auth/signup/index";
import ForgotPasswordPage from "../modules/app-auth/forgot-password/index";
import ChangePasswordPage from "../modules/app-auth/change-password/index";
import { useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";

import Profile from "../modules/app-seguridad/Profile/profile";
import ChangePassword from "../modules/app-seguridad/Profile/changePassword";

//SEGURIDAD
import SessionTimeout from "../session/SessionTimeout";
import Home from "../modules/home/index";

//SEGURIDAD
import Users from "../modules/app-seguridad/Users/Users";
import Roles from "../modules/app-seguridad/Roles/roles";

//CREDITO
import SolicitudesList from "../modules/app-credito/pages/SolicitudesList";
import RevisionAnalista from "../modules/app-credito/pages/RevisionAnalista";
import Preevaluacion from "app/modules/app-credito/pages/Preevaluacion";
import FlujoPuntaPage from "app/modules/app-credito/pages/FlujoPuntaPage";
import DigitacionPage from "app/modules/app-credito/pages/DigitacionPage";
import DigitacionSolicitudPage from "app/modules/app-credito/pages/DigitacionSolicitudPage";
import AumentoCupoPage from "app/modules/app-credito/pages/AumentoCupoPage";
import FlujoAumentoCupo from "app/modules/app-credito/pages/FlujoAumentoCupo";
import ConsulmaxPage from "app/modules/app-credito/pages/ConsulmaxPage";
import GestionDevueltasPage from "app/modules/app-credito/pages/GestionDevueltasPage";
import CrediwebDocsPage from "app/modules/app-credito/pages/CrediwebDocsPage";
import AnexarPdfPage from "app/modules/app-credito/pages/AnexarPdfPage";
import GestionSolicitudPage from "app/modules/app-credito/pages/GestionSolicitudPage";
import ConsultarSolicitudesPage from "app/modules/app-credito/pages/ConsultarSolicitudesPage";
import TrackingSolicitudPage from "app/modules/app-credito/pages/TrackingSolicitudPage";

//CLIENET
import ClienteInformacion from "app/modules/app-cliente/pages/ClienteInformacion";
import ClienteEstadoFinanciero from "app/modules/app-cliente/pages/ClienteEstadoFinanciero";
import ClienteReferencias from "app/modules/app-cliente/pages/ClienteReferencias";

/* MANTENEDORES */
import LocalesCatalogo from "app/modules/app-configuracion/pages/LocalInformacion";
import ColaboradoresCatalogo from "app/modules/app-configuracion/pages/ColaboradorInformacion";
import DesbloqueoUsuario from "app/modules/app-seguridad/DebloqueoUsuarios/Pages/DesbloqueoUsuario";
import AsignarLocalUsuario from "app/modules/app-seguridad/AsignarLocalUsuario/Pages/AsignarLocalUsuario";
import FlujoUsuario from "app/modules/app-seguridad/FlujoUsuario/Pages/FlujoUsuario";

/*TRANSACCIONAL */
import ProspeccionCliente from "app/modules/app-consultaTransaccional/pages/ProspeccionCliente";

const Routes = () => {
  const { authUser, code } = useSelector(({ auth }) => auth);
  const [sendLogout, setSendLogout] = useState(false);
  const [init, setInit] = useState(localStorage.getItem("init"));

  // para cerrra la session
  let data = JSON.parse(sessionStorage.getItem("user"));
  const userCode = data ? data.key : "";

  useOnLogout(userCode, sendLogout, setSendLogout);
  // fin pra cerrar la session

  const location = useLocation();
  let lista = sessionStorage.getItem("menu");
  //let init = localStorage.getItem("init");

  if (sessionStorage.getItem("conectado") !== "true") {
    if (location.pathname === "" || location.pathname === "/") {
      if (init !== null) return <Redirect to={`/${init}`} />;
      else location.pathname = "/signincli";
    }

    if (
      location.pathname != "/auth-pages/otpregistro" &&
      location.pathname != "/auth-pages/otp" &&
      location.pathname != "/auth-pages/validarcedula" &&
      location.pathname != "/otp" &&
      location.pathname != "/signincli" &&
      location.pathname != "/home-page" &&
      location.pathname != "/initialHome" &&
      location.pathname != "/auth-pages/welcome" &&
      location.pathname != "/auth-pages/datos" &&
      location.pathname != "/credito/flujop" &&
      location.pathname != "//auth-pages/terminos"
    )
      location.pathname = "/signincli";
  }

  if (
    authUser === null &&
    code === null &&
    location.pathname !== "/signincli"
  ) {
    switch (location.pathname) {
      case "/auth-pages/welcome":
        location.pathname = "/auth-pages/welcome";
        break;
      case "/auth-pages/otp":
        location.pathname = "/auth-pages/otp";
        break;
      case "/auth-pages/otpregistro":
        location.pathname = "/auth-pages/otpregistro";
        break;
      case "/auth-pages/datos":
        location.pathname = "/auth-pages/datos";
        break;
      case "/auth-pages/terminos":
        location.pathname = "/auth-pages/terminos";
        break;
      case "/auth-pages/validarcedula":
        location.pathname = "/auth-pages/validarcedula";
        break;
      default:
        location.pathname = "/signincli";
        break;
    }
  }

  if (
    lista != null &&
    location.pathname != undefined &&
    location.pathname != "/otp" &&
    location.pathname != "/signincli" &&
    location.pathname != "/home-page" &&
    location.pathname != "/initialHome" &&
    location.pathname != "/auth-pages/otp" &&
    location.pathname != "/auth-pages/otpregistro" &&
    location.pathname != "/auth-pages/welcome" &&
    location.pathname != "/auth-pages/datos" &&
    location.pathname != "/auth-pages/validarcedula" &&
    location.pathname != "/credito/flujop" &&
    location.pathname != "/transaccional/movimientosCliente" &&
    location.pathname != "//auth-pages/terminos"
  ) {
    if (lista.search(location.pathname) < 0) {
      location.pathname = "/signincli";
      alert("Por favor vuelve a iniciar Sesion.");
    }
  }

  const handleClick = () => {
    setSendLogout(true);
  };

  return (
    <React.Fragment>
      <Switch>
        <Route path="/home" component={Home} />
        <Route path="/signin" component={Login} />
        <Route path="/otp" component={Otp} />
        <Route path="/signup" component={Signup} />
        <Route path="/forgot-password" component={ForgotPasswordPage} />
        <Route path="/password" component={ChangePasswordPage} />
        <Route path="/app/profile-user" component={Profile} />
        <Route path="/app/change-password" component={ChangePassword} />

        {/* //AUTH CLIENTE */}
        <Route path="/signincli" component={LoginCli} />

        <Route path="/auth-pages/otp" component={OtpCli} />
        <Route path="/auth-pages/otpregistro" component={OtpRegistro} />
        <Route path="/auth-pages/welcome" component={Welcome} />
        <Route path="/auth-pages/datos" component={Datos} />
        <Route path="/auth-pages/terminos" component={Terminos} />
        <Route path="/auth-pages/validarcedula" component={ValidarCedula} />

        {/* //SEGURIDAD */}
        <Route path="/perfil" component={Roles} />
        <Route
          path="/usuario/desbloqueoUsuarios"
          component={DesbloqueoUsuario}
        />
        <Route
          path="/usuario/asignarLocalUsuario"
          component={AsignarLocalUsuario}
        />
        <Route path="/usuario/flujoUsuario" component={FlujoUsuario} />
        <Route path="/usuario" component={Users} />
        {/* <Route path="/firma" component={Firma} /> */}

        {/* //CREDITO */}
        <Route path="/credito/preevaluacion" component={Preevaluacion} />
        <Route path="/credito/flujop" component={FlujoPuntaPage} />
        <Route path="/credito/solicitudes" component={SolicitudesList} />
        <Route path="/credito/RevisionAnalista" component={RevisionAnalista} />
        <Route path="/credito/digitacion" component={DigitacionPage} />
        <Route
          path="/credito/digitacionSolicitud"
          component={DigitacionSolicitudPage}
        />
        <Route path="/credito/aumentoCupo" component={AumentoCupoPage} />
        <Route path="/credito/aumentoCupoForm" component={FlujoAumentoCupo} />
        <Route path="/credito/consulmax" component={ConsulmaxPage} />
        <Route path="/credito/devueltas" component={GestionDevueltasPage} />
        <Route
          path="/credito/documentosCrediweb"
          component={CrediwebDocsPage}
        />
        <Route path="/credito/anexarSolicitud" component={AnexarPdfPage} />
        <Route
          path="/credito/gestionSolicitud"
          component={GestionSolicitudPage}
        />
        <Route
          path="/credito/consultaSolicitudes"
          component={ConsultarSolicitudesPage}
        />
        <Route
          path="/credito/trackingSolicitud"
          component={TrackingSolicitudPage}
        />

        {/* CLIENTE */}
        <Route path="/cliente/crear" component={SolicitudesList} />
        <Route
          path="/cliente/administrar/informacion"
          component={ClienteInformacion}
        />
        <Route
          path="/cliente/administrar/financiero"
          component={ClienteEstadoFinanciero}
        />
        <Route
          path="/cliente/administrar/referencias"
          component={ClienteReferencias}
        />

        {/* TRANSACCIONAL */}
        <Route
          path="/transaccional/movimientosCliente"
          component={ProspeccionCliente}
        />

        {/* MANTENEDORES */}
        <Route path="/catalogo/listarLocales" component={LocalesCatalogo} />

        <Route
          path="/catalogo/listarColaboradores"
          component={ColaboradoresCatalogo}
        />
      </Switch>
      <SessionTimeout
        isAuthenticated={authUser === null ? false : true}
        logOut={handleClick}
      />
    </React.Fragment>
  );
};

export default Routes;
